import api from "../apiConfig";
const paramsFactory = (p) => {
  const params = new URLSearchParams();
  if (p) {
    Object.keys(p).forEach((key) => {
      if (p[key] !== null && p[key] !== undefined && p[key] !== "") {
        params.append(key, p[key]);
      }
    });
  }
  return params;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  getAll(params) {
    const p = paramsFactory(params);
    return api.get(`/api/v1/settings?${p}`);
  },
  getFingerPrintDevices() {
    return api.get(`/api/v1/fingerprint-devices`);
  },
  uploadApk(data) {
    return api.post(`/api/v1/upload-apk`, data);
  },
  newVersion(data) {
    return api.post(`/api/v1/settings`, data);
  },
  update(data) {
    return api.put(`/api/v1/settings/${data.id}`, data);
  },
};
